import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

export const createUiSlice = (set: SetState<AskPerformYardState>) => ({
	isOpen: false,
	isExpanded: false,
	isPanelOpen: false,
	forceHidden: false,

	open: () => set({ isOpen: true }),
	close: () => set({ isOpen: false }),
	toggleExpand: () => set((state) => ({ isExpanded: !state.isExpanded })),
	// Opening the docked panel closes the floating FAB window — one Ask PY surface at a time.
	openPanel: () => set({ isPanelOpen: true, isOpen: false }),
	closePanel: () => set({ isPanelOpen: false }),
	setInputValue: (value: string) => set({ inputValue: value }),
	setForceHidden: (hidden: boolean) => set({ forceHidden: hidden }),
});
